// scamActions.js
import { deleteScamApi, fetchMyScamAlerts, postScam } from "src/api_endpoints/userDashboard/ScamAPI"; // Ensure this import is correct

// Action types

export const FETCH_SCAMS_REQUEST = "FETCH_SCAMS_REQUEST";
export const FETCH_SCAMS_SUCCESS = "FETCH_SCAMS_SUCCESS";
export const FETCH_SCAMS_FAILURE = "FETCH_SCAMS_FAILURE";

export const SUBMIT_SCAM_REQUEST = "SUBMIT_SCAM_REQUEST";
export const SUBMIT_SCAM_SUCCESS = "SUBMIT_SCAM_SUCCESS";
export const SUBMIT_SCAM_FAILURE = "SUBMIT_SCAM_FAILURE";

export const LIKE_SCAM = 'LIKE_SCAM';
export const DISLIKE_SCAM = 'DISLIKE_SCAM';
export const NEUTRAL_SCAM = 'NEUTRAL_SCAM';
export const INC_COMMENT_COUNT = 'INC_COMMENT_COUNT';


export const REMOVE_SCAM = "REMOVE_SCAM";
export const SUBMIT_PRESCAM = "SUBMIT_PRESCAM";

// Action creators for fetching scams
export const fetchScamsRequest = () => ({ type: FETCH_SCAMS_REQUEST });
export const fetchScamsSuccess = (data) => ({ type: FETCH_SCAMS_SUCCESS, payload: data });
export const fetchScamsFailure = (error) => ({ type: FETCH_SCAMS_FAILURE, payload: error });

// Action creators for submitting a scam
export const submitScamRequest = () => ({ type: SUBMIT_SCAM_REQUEST });
export const submitScamSuccess = (data) => ({ type: SUBMIT_SCAM_SUCCESS, payload: data });
export const submitScamFailure = (error) => ({ type: SUBMIT_SCAM_FAILURE, payload: error });
export const submitPreScamSuccess = (data) => ({
  type: SUBMIT_PRESCAM,
  payload: data,
});



// Action creator for removing a scam
export const removeScam = (id) => ({ type: REMOVE_SCAM, payload: id });

// Thunk to fetch scams
export const fetchScams = (userId) => {
  return async (dispatch) => {
    dispatch(fetchScamsRequest());

    try {
      const response = await fetchMyScamAlerts({ userId });
      // console.log('scamActions.js fetchMyScamAlerts: ',response.scams)
      dispatch(fetchScamsSuccess(response.scams)); // Ensure you access the scams array from the response
    } catch (error) {
      dispatch(fetchScamsFailure("Failed to fetch scam alerts."));
      console.error("Error fetching scam alerts:", error);
    }
  };
};

// Thunk to submit a scam
export const submitScam = (formData) => {
  return async (dispatch) => {
    dispatch(submitScamRequest());

    try {
      const response = await postScam(formData);

      if (response?.error) {
        dispatch(submitScamFailure(response?.message || "Failed to submit scam report"));
      } else {
        const { status, message, ...scamData } = response;
        dispatch(submitScamSuccess(scamData)); 
      }
    } catch (error) {
      dispatch(submitScamFailure("Error submitting scam report."));
      console.error("Error submitting scam report:", error);
    }
  };
};

// Thunk to remove a scam (optional)
export const deleteScam = (data) => async (dispatch) => {
  try {
    const response = await deleteScamApi(data)
    if(response.success){
      dispatch(removeScam(data.scam_id));
    }
  } catch (error) {
    console.error("Error deleting scam:", error);
  }
};
// Like a scam post
export const likeScam = (scamId) => ({
  type: LIKE_SCAM,
  payload: { scamId, reaction_type: 1 }, // 1 represents "like"
});

// Dislike a scam post
export const dislikeScam = (scamId) => ({
  type: DISLIKE_SCAM,
  payload: { scamId, reaction_type: 2 }, // 2 represents "dislike"
});

export const incCommentCount = (scamId) => ({
  type: INC_COMMENT_COUNT,
  payload: scamId, // 1 represents "like"
});
// Set a scam post reaction to neutral
export const neutralScam = (scamId) => ({
  type: NEUTRAL_SCAM,
  payload: { scamId, reaction_type: null }, // null represents "neutral"
});

// Thunk to store pre-scam data locally without API call
export const submitPreScam = (formData) => {
  return (dispatch) => {
    // Simulate storing the form data in state without making an API request
    dispatch(submitPreScamSuccess(formData));
  };
};

